import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import DeleteForever from "@material-ui/icons/DeleteForever";
import DialogConfirm from "./DialogConfirm";
import {
  IconButton,
  Button
} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonDelete({ record_id, reloadData }) {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOnOpen = () => {
    setIsDialogOpen(true);
  };
  const handleOnClose = () => {
    setIsDialogOpen(false);
  }; 
 
  return (
    <>
      {record_id&&(
        <IconButton onClick={handleOnOpen}>
          <DeleteForever/>
        </IconButton>      
      )}      
      <DialogConfirm
        //fullScreen
        open={isDialogOpen}
        onClose={handleOnClose}
        record_id = {record_id}
        reloadData={reloadData}
      />
    </>
  );
}
